import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './MasterclassCurriculum.css';

const MasterclassCurriculum = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start center", "end center"]
  });

  const scaleY = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section className="mc-section" id="curriculum" ref={containerRef}>
      <div className="mc-curriculum-header">
        <h2 className="mc-gradient-accent">The 3-Week Transformation</h2>
        <div className="mc-curriculum-divider"></div>
      </div>

      <div className="mc-timeline">
        <div className="mc-timeline-progress-bg"></div>
        <motion.div
          className="mc-timeline-progress-fill"
          style={{ height: scaleY }}
        />

        {/* WEEK 1 */}
        <div className="mc-timeline-item left">
          <div className="mc-timeline-dot"></div>
          <div className="mc-timeline-text">
            <span className="mc-week-label mc-gradient-accent">WEEK 01</span>
            <h3 className="mc-timeline-title">Foundation & Flow</h3>
            <p className="mc-timeline-desc">Mastering the bridge between human intent and machine execution. No more generic outputs.</p>
          </div>
          <div className="mc-timeline-content mc-glass-card">
            <ul className="mc-timeline-list">
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">1</div>
                <div>
                  <h4 className="mc-timeline-list-title">Introduction to Course, Prompt Engineering</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">2</div>
                <div>
                  <h4 className="mc-timeline-list-title">LLM Fundamentals Part-1</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">3</div>
                <div>
                  <h4 className="mc-timeline-list-title">LLM In Depth Part-2</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">4</div>
                <div>
                  <h4 className="mc-timeline-list-title">Image Generation</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">5</div>
                <div>
                  <h4 className="mc-timeline-list-title">Video Generation</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>

            </ul>
          </div>
        </div>

        {/* WEEK 2 */}
        <div className="mc-timeline-item right">
          <div className="mc-timeline-dot"></div>
          <div className="mc-timeline-text">
            <span className="mc-week-label mc-gradient-accent">WEEK 02</span>
            <h3 className="mc-timeline-title">Visual Synthesis</h3>
            <p className="mc-timeline-desc">Turn concepts into photorealistic visuals and cinematic video in seconds.</p>
          </div>
          <div className="mc-timeline-content mc-glass-card" style={{ borderLeft: 'none', borderRight: '4px solid var(--mc-primary)' }}>
            <ul className="mc-timeline-list">
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">1</div>
                <div>
                  <h4 className="mc-timeline-list-title">Voice & Calling</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">2</div>
                <div>
                  <h4 className="mc-timeline-list-title">Productivity</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">3</div>
                <div>
                  <h4 className="mc-timeline-list-title">UI/UX Design</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">4</div>
                <div>
                  <h4 className="mc-timeline-list-title">Workflow automation</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">5</div>
                <div>
                  <h4 className="mc-timeline-list-title">No Code</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">6</div>
                <div>
                  <h4 className="mc-timeline-list-title">Vibe Coding</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* WEEK 3 */}
        <div className="mc-timeline-item left">
          <div className="mc-timeline-dot"></div>
          <div className="mc-timeline-text">
            <span className="mc-week-label mc-gradient-accent">WEEK 03</span>
            <h3 className="mc-timeline-title">Scale & Automation</h3>
            <p className="mc-timeline-desc">Transition from individual tasks to autonomous, scalable systems.</p>
          </div>
          <div className="mc-timeline-content mc-glass-card">
            <ul className="mc-timeline-list">
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">1</div>
                <div>
                  <h4 className="mc-timeline-list-title">Smart IDE's</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">2</div>
                <div>
                  <h4 className="mc-timeline-list-title">Plugins</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">3</div>
                <div>
                  <h4 className="mc-timeline-list-title">Work Flow Customization</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">4</div>
                <div>
                  <h4 className="mc-timeline-list-title">DevOps + Version Control + CI/CD Pipeline</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">5</div>
                <div>
                  <h4 className="mc-timeline-list-title">End-to-End Application Development</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
              <li className="mc-timeline-list-item">
                <div className="mc-timeline-icon">6</div>
                <div>
                  <h4 className="mc-timeline-list-title">Project-Build-Deployment</h4>
                  <p className="mc-timeline-list-desc"></p>
                </div>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </section>
  );
};

export default MasterclassCurriculum;
